import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth APIs
export const authAPI = {
  login: (email, password) => api.post('/api/auth/login', { email, password }),
  register: (userData) => api.post('/api/auth/register', userData),
  getMe: () => api.get('/api/auth/me'),
};

// Leads APIs
export const leadsAPI = {
  // ✅ NEW: Get dashboard data (stats + action center) - for OwnerDashboard
  getDashboardData: (viewMode = 'all') => 
    api.get('/api/leads/dashboard-data', { params: { viewMode } }),
  
  // ✅ UPDATED: Get paginated leads - for Leads table
  getAll: (params) => api.get('/api/leads', { params }),
  
  // Alias for clarity
  getPaginated: (page = 1, limit = 50, filters = {}) => 
    api.get('/api/leads', { params: { page, limit, ...filters } }),
  
  getOne: (id) => api.get(`/api/leads/${id}`),
  create: (data) => api.post('/api/leads', data),
  update: (id, data) => api.put(`/api/leads/${id}`, data),
  delete: (id) => api.delete(`/api/leads/${id}`),
  import: (leads) => api.post('/api/leads/import', { leads }),
};

// Messages APIs
export const messagesAPI = {
  getAll: (params) => api.get('/api/messages', { params }),
  getForLead: (leadId) => api.get(`/api/messages/lead/${leadId}`),
  send: (data) => api.post('/api/messages/send', data),
};

// Drips APIs
export const dripsAPI = {
  getAll: () => api.get('/api/drips'),
  getOne: (id) => api.get(`/api/drips/${id}`),
  create: (data) => api.post('/api/drips', data),
  update: (id, data) => api.put(`/api/drips/${id}`, data),
  delete: (id) => api.delete(`/api/drips/${id}`),
  enrollLead: (dripId, leadId) => api.post(`/api/drips/${dripId}/enroll/${leadId}`),
  pauseLead: (dripId, leadId) => api.post(`/api/drips/${dripId}/pause/${leadId}`),
};

// ✅ NEW: Two-Factor Authentication APIs
export const twoFactorAPI = {
  // Get 2FA status for current user
  getStatus: () => api.get('/api/2fa/status'),
  
  // Initialize 2FA setup (generates QR code)
  setup: () => api.post('/api/2fa/setup'),
  
  // Verify setup and enable 2FA
  verifySetup: (token) => api.post('/api/2fa/verify-setup', { token }),
  
  // Verify 2FA code during login
  verify: (userId, token, isBackupCode = false) => 
    api.post('/api/2fa/verify', { userId, token, isBackupCode }),
  
  // Disable 2FA (requires password)
  disable: (password, token) => api.post('/api/2fa/disable', { password, token }),
  
  // Generate new backup codes (requires password)
  generateBackupCodes: (password) => api.post('/api/2fa/backup-codes', { password })
};

export default api;